/**
 * Debug localStorage changes to find what's reverting selectedLanguage
 */

class LocalStorageDebugger {
    private originalSetItem: typeof Storage.prototype.setItem;
    
    constructor() {
        this.originalSetItem = Storage.prototype.setItem;
        this.interceptLocalStorage();
    }
    
    private interceptLocalStorage(): void {
        const self = this;
        
        Storage.prototype.setItem = function(key: string, value: string) {
            // Log all changes to selectedLanguage
            if (key === 'selectedLanguage') {
                
                // Check current value before setting
                const currentValue = localStorage.getItem('selectedLanguage');
                if (currentValue !== value) {
                    console.warn(`📝 selectedLanguage changing from '${currentValue}' to '${value}'`);
                }
                
                // Add a breadcrumb to track the source
                const error = new Error();
                const stack = error.stack || '';
                
                if (stack.includes('googleTranslateHelper')) {
                    console.warn('⚠️ Change from googleTranslateHelper');
                } else if (stack.includes('GoogleTranslateManager')) {
                    console.warn('⚠️ Change from GoogleTranslateManager');
                } else if (stack.includes('LanguageDropdown')) {
                    console.warn('⚠️ Change from LanguageDropdown');
                } else {
                    console.warn('⚠️ Change from unknown source');
                }
            }
            
            // Call original setItem
            return self.originalSetItem.call(this, key, value);
        };
        
    }
}

// Initialize debugger
new LocalStorageDebugger();

export {};